import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'

export default function InfoBox({ children, header }: any) {
	return (
		<Grid item md={12}>
			<Typography variant="h6" sx={{ fontWeight: 800 }}>
				{header}
			</Typography>
			<Typography variant="body1">{children}</Typography>
		</Grid>
	)
}
